const POSTS = [
  {
    n: "01",
    title: "On the honesty of travertine",
    date: "Aug 2025",
    tag: "Materials",
    excerpt: "Notes from a quarry visit in Rajasthan, and why we've stopped hiding stone joins.",
  },
  {
    n: "02",
    title: "The five-hour hotel arrival",
    date: "Jun 2025",
    tag: "Hospitality",
    excerpt: "Why the first five hours of a guest's stay does most of the design work.",
  },
  {
    n: "03",
    title: "A room in three lights",
    date: "Apr 2025",
    tag: "Craft",
    excerpt: "How we test every lounge under morning, dusk and monsoon light.",
  },
];

export default function Journal() {
  return (
    <main className="bg-bone" data-testid="journal-page">
      <section className="pt-40 md:pt-56 pb-24 md:pb-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <p className="text-[11px] uppercase tracking-[0.3em] text-muteInk mb-6">— Journal</p>
          <h1 className="font-serif text-[12vw] md:text-[8vw] leading-[0.9] tracking-tight text-ink">
            Notes from<br /><span className="italic text-clay">the studio.</span>
          </h1>
        </div>
      </section>

      <section className="pb-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 divide-y divide-borderWarm border-t border-borderWarm">
          {POSTS.map((p) => (
            <a
              key={p.n}
              href="#"
              className="grid grid-cols-12 gap-6 py-10 md:py-14 group hoverable"
            >
              <div className="col-span-3 md:col-span-2">
                <span className="chapter-num text-3xl">{p.n}</span>
              </div>
              <div className="col-span-9 md:col-span-6">
                <h3 className="font-serif text-3xl md:text-4xl text-ink group-hover:italic transition-all duration-500 tracking-tight leading-tight">{p.title}</h3>
                <p className="text-ink/70 mt-4 max-w-lg leading-relaxed">{p.excerpt}</p>
              </div>
              <div className="col-span-12 md:col-span-4 md:text-right">
                <p className="text-[11px] uppercase tracking-[0.28em] text-muteInk">{p.tag} · {p.date}</p>
                <p className="mt-4 text-[12px] uppercase tracking-[0.22em] text-clay editorial-link inline-block">Read →</p>
              </div>
            </a>
          ))}
        </div>
      </section>
    </main>
  );
}
